import * as React from 'react';
import Avatar from '../../Avatar';
import Clearfix from '../../Clearfix';
import Flex from '../../Flex';
import TimeAgo from '../../TimeAgo';
import {styled} from '../../../utils';
import ChatBubble from '../ChatBubble';
import {ChatBubbleGroupProps} from './types';
import {padding} from 'polished';

const Root = styled(Flex)(padding(8, 0));

const Main = styled('div')({
  ...padding(2, 16, 0),
  flexGrow: 1
});

const Meta = styled('div')<{fromCurrentUser: boolean}>(({fromCurrentUser, theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: theme.fontSize.small,
  lineHeight: '1.5',
  color: '#7E8DA6',
  marginBottom: 8,
  float: fromCurrentUser ? 'right' : 'left'
}));

const SenderNameText = styled('span')({
  fontWeight: 'bold',
  marginRight: 5
});

export default class ChatBubbleGroup extends React.Component<ChatBubbleGroupProps, {}> {
  public render() {
    return (
      <Root>
        {this._renderAvatar()}
        <Main>
          {this._renderMeta()}
          {this._renderBubbles()}
        </Main>
      </Root>
    );
  }

  private get _firstMessage() {
    return this.props.messages[0];
  }

  private _renderAvatar() {
    return this.props.fromCurrentUser ? null : (
      <Avatar src={this._firstMessage.senderAvatar} circle={true} larger={true} />
    );
  }

  private _renderMeta() {
    const {fromCurrentUser, showSenderName, showStartTime} = this.props;
    const {senderName, createdAt} = this._firstMessage;

    return (
      <Clearfix>
        <Meta fromCurrentUser={fromCurrentUser}>
          {showSenderName && !fromCurrentUser ? <SenderNameText>{senderName} </SenderNameText> : null}
          {showStartTime ? <TimeAgo date={createdAt} /> : null}
        </Meta>
      </Clearfix>
    );
  }

  private _renderBubbles() {
    const {messages, fromCurrentUser} = this.props;
    return messages.map((m, index) => <ChatBubble message={m} key={index} fromCurrentUser={fromCurrentUser} />);
  }
}



// WEBPACK FOOTER //
// ./src/components/ChatUI/ChatBubbleGroup/ChatBubbleGroup.tsx